exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.h2_title[data-v-2c1041c4] {\n  font-weight: normal;\n}\n.disable-events[data-v-2c1041c4] {\n  pointer-events: none !important;\n}\n", ""]);

// exports
